import FastFilter from './FastFilter';
import TableFastFilter from './TableFastFilter';
export { TableFastFilter, FastFilter };
export default FastFilter;
